import React from "react";
import style from "./style.scss";

export const FormDivider = () => {
    return <div className={style.base}></div>;
};
